import { render, staticRenderFns } from "./ChatMember.vue?vue&type=template&id=01fc78de&"
import script from "./ChatMember.vue?vue&type=script&lang=js&"
export * from "./ChatMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports